<template>
    <div style="margin:0 10px">
        <div class="card">
            <!-- header -->
            <div class="search d-flex a-center j-sb">
                <div class="d-flex a-center">
                    <h3 style="margin:0;color:#17233d;">{{ courseName }} - 章节结构</h3>
                </div>
                <div class="d-flex a-center">
                    <el-button type="primary" size="small" @click="showAddDialog()">
                        <i class="el-icon-plus"></i> 添加章节
                    </el-button>
                    <el-button type="info" size="small" plain @click="$router.push({name:'course'})">
                        <i class="el-icon-back"></i> 返回课程
                    </el-button>
                </div>
            </div>

            <!-- table -->
            <div class="table" style="margin-top:20px;">
                <el-table
                    row-key="id"
                    :data="tableData"
                    style="width: 100%;"
                    v-loading="loading"
                    element-loading-background="rgba(255,255,255, 0.6)"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    default-expand-all
                >
                    <el-table-column prop="name" label="章节名称" align="left" min-width="250"></el-table-column>
                    <el-table-column prop="sort" label="排序" align="center" width="80"></el-table-column>
                    <el-table-column prop="" label="操作" align="center" width="250">
                        <template slot-scope="scope">
                            <el-button @click="showAddDialog(scope.row.id)" type="text" size="small" style="color:#67C23A;">添加子章节</el-button>
                            <el-button @click="showEditDialog(scope.row)" type="text" size="small" class="edit-action">编辑</el-button>
                            <el-popconfirm
                                style="margin-left: 10px;"
                                title="是否确定删除？"
                                @confirm="handleDel(scope.row)"
                            >
                                <el-button type="text" slot="reference" size="small" class="delete-action">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 添加/编辑章节弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="resetForm">
            <el-form :model="form" :rules="rules" ref="chapterForm" label-width="100px">
                <el-form-item label="章节名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入章节名称"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right"></el-input-number>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input type="textarea" rows="3" v-model="form.description" placeholder="请输入描述（可选）"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { chapter_tree, chapter_save, chapter_del } from '@/request/api/course.js'

export default {
    data() {
        return {
            courseId: '',
            courseName: '',
            tableData: [],
            loading: false,
            dialogVisible: false,
            isEdit: false,
            form: {
                id: '',
                courseId: '',
                parentId: '',
                name: '',
                sort: 0,
                description: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入章节名称', trigger: 'blur' }
                ],
            },
        }
    },
    computed: {
        dialogTitle() {
            if (this.isEdit) return '编辑章节'
            return this.form.parentId ? '添加子章节' : '添加章节'
        }
    },
    created() {
        this.courseId = this.$route.query.courseId || ''
        this.courseName = this.$route.query.courseName || ''
        this.init()
    },
    methods: {
        init() {
            this.loading = true
            chapter_tree({ courseId: this.courseId }).then(res => {
                this.tableData = res.data || []
            }).finally(() => {
                this.loading = false
            })
        },
        showAddDialog(pid) {
            this.isEdit = false
            this.form = {
                id: '',
                courseId: this.courseId,
                parentId: pid || '',
                name: '',
                sort: 0,
                description: '',
            }
            this.dialogVisible = true
        },
        showEditDialog(row) {
            this.isEdit = true
            this.form = {
                id: row.id,
                courseId: this.courseId,
                parentId: row.parentId || '',
                name: row.name || '',
                sort: row.sort || 0,
                description: row.description || '',
            }
            this.dialogVisible = true
        },
        submitForm() {
            this.$refs['chapterForm'].validate((valid) => {
                if (valid) {
                    const submitData = { ...this.form }
                    if (!this.isEdit) { delete submitData.id }
                    chapter_save(submitData).then(res => {
                        if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg })
                        this.$notify({ title: '成功', message: this.isEdit ? '编辑成功' : '添加成功', type: 'success' })
                        this.dialogVisible = false
                        this.init()
                    })
                }
            })
        },
        handleDel(data) {
            chapter_del(data.id).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg })
                this.init()
                this.$notify({ title: '成功', message: '删除成功', type: 'success' })
            })
        },
        resetForm() {
            if (this.$refs['chapterForm']) {
                this.$refs['chapterForm'].resetFields()
            }
        },
    }
}
</script>

<style scoped lang="less">
.card {
    border-radius: 4px;
    padding: 20px;
}
.edit-action {
    color: #409eff;
    &:hover {
        color: #66b1ff;
    }
}
.delete-action {
    color: #f56c6c;
    &:hover {
        color: #f78989;
    }
}
</style>
